import {
  FETCH_PRODUCT_REVIEWS_LIST,
  FETCH_PRODUCT_SUMMARY_REVIEWS,
  SET_RESERVE,
  VIOLATION_REPORT,
  SET_REQUEST,
  GET_CANCELLATION_RULES,
} from './../actions/types'
import {
  FETCH_PRODUCT,
  FETCH_PRODUCT_PICTURES,
  FETCH_PROFORMA,
  FETCH_REVIEWS,
  FETCH_WEATHER,
  SET_BOOKMARK,
} from '../actions/types'
import { AnyAction } from 'redux'
import {
  BookmarkActionProps,
  BookmarkStateProps,
  PicturesActionProps,
  PicturesStateProps,
  ProductActionProps,
  ProductStateProps,
  ProformaActionProps,
  ProformaStateProps,
  RequestActionProps,
  ReserveActionProps,
  ReserveStateProps,
  ReviewsState,
  WeatherActionProps,
  WeatherStateProps,
  requestToVisitHouse,
} from '../types'

export const product = (
  state: ProductStateProps = {
    data: {
      is_mid_term: false,
      is_units_count: false,
    },
    loading: false,
    status: null,
  },
  { type, data, loading, status }: ProductActionProps,
): ProductStateProps => {
  switch (type) {
    case FETCH_PRODUCT:
      return { data, loading, status }

    default:
      return state
  }
}

export const initialReviewState: ReviewsState = {
  loading: false,
  list: [],
  count: 0,
  page: 1,
  suggest: {},
  hasMore: true,
}

export const reviews = (
  state: ReviewsState = initialReviewState,
  action: AnyAction,
) => {
  switch (action.type) {
    case FETCH_REVIEWS:
      return {
        ...state,
        loading: action.loading,
        list: action.payload,
        count: action.count,
        page: action.page,
        suggest: action.suggest,
        hasMore: action.hasMore,
      }

    default:
      return state
  }
}

// weather:
export const weather = (
  state: WeatherStateProps = { data: [], loading: false },
  { type, data, loading }: WeatherActionProps,
): WeatherStateProps => {
  switch (type) {
    case FETCH_WEATHER:
      return { data, loading }

    default:
      return state
  }
}

// proforma:
export const proforma = (
  state: ProformaStateProps = { data: null, loading: false },
  { type, data, loading }: ProformaActionProps,
): ProformaStateProps => {
  switch (type) {
    case FETCH_PROFORMA: {
      return { data, loading }
    }

    default:
      return state
  }
}

export const pictures = (
  state: PicturesStateProps = { data: [], loading: false },
  { type, data, loading }: PicturesActionProps,
): PicturesStateProps => {
  switch (type) {
    case FETCH_PRODUCT_PICTURES:
      return { data, loading }

    default:
      return state
  }
}

export const reserve = (
  state: ReserveStateProps = { data: null, loading: false },
  { type, data, loading }: ReserveActionProps,
): ReserveStateProps => {
  switch (type) {
    case SET_RESERVE:
      return { data, loading }

    default:
      return state
  }
}
export const requestToVisit = (
  state: requestToVisitHouse = { data: null, loading: false },
  { type, data, loading }: RequestActionProps,
): requestToVisitHouse => {
  switch (type) {
    case SET_REQUEST:
      return { data, loading }

    default:
      return state
  }
}

export interface ReportType {
  id: number
  description: string
}
export interface ViolationReportType {
  data: ReportType | null
  loading: boolean
}
export const violationReport = (
  state: ViolationReportType = { data: null, loading: false },
  action,
) => {
  switch (action.type) {
    case VIOLATION_REPORT:
      return {
        data: action.data,
        loading: action.loading,
      }

    default:
      return state
  }
}
export interface ProductType {
  data: any
  loading: boolean
  page: number
}
export const productReducer = (
  state: ProductType = {
    data: null,
    loading: false,
    page: 1,
  },
  action,
) => {
  switch (action.type) {
    case FETCH_PRODUCT_SUMMARY_REVIEWS:
      return {
        ...state,
        data: {
          ...state.data,
          productReviews: {
            data: action.data,
            loading: action.loading,
          },
        },
      }
    case FETCH_PRODUCT_REVIEWS_LIST:
      return {
        ...state,
        data: {
          ...state.data,
          productReviewsList: {
            data: action.data,
            loading: action.loading,
          },
        },
      }
    case GET_CANCELLATION_RULES: {
      return {
        ...state,
        data: {
          ...state.data,
          cancellationRules: {
            data: action.data,
            id: action.id,
            loading: action.loading,
          },
        },
      }
    }
    default:
      return state
  }
}
